import type { Verbiage } from "@repo/models";

import { useQuery } from "@tanstack/react-query";

import { BaseController } from "./baseController";
import { QUERY_KEYS } from "./queryKeys";

const controller = "Locations";

export function useVerbiageQuery() {
	const Get = BaseController.GetFn(controller);

	const defaultVerbiage = {
		fieldAudit: "Field Audit",
		location: "Location",
		office: "Office",
		marketer: "Marketer",
		partner: "Partner",
		partnerType: "Partner Type",
		retailLocation: "Retail Location",
	};

	const { data, isFetching: verbiageLoading } = useQuery({
		queryKey: [QUERY_KEYS.Locations.Verbiage],
		queryFn: () => Get<Verbiage>("GetVerbiage"),
		placeholderData: defaultVerbiage,
	});

	const verbiage = data ?? defaultVerbiage;

	return { verbiage, verbiageLoading };
}
